// extracted by mini-css-extract-plugin
export default {"wrapper":"ActionButton_wrapper__M9Cb1","text":"ActionButton_text__ttyQH"};